<main class="auth-page">
  <section class="auth-shell" aria-labelledby="forgot-title">
    <div class="auth-shell__accent"></div>
    <div class="auth-content">
      <a class="auth-brand" routerLink="/login" aria-label="GarageDigital">
        <img src="assets/images/GD_Logotipo_UI.png" alt="GarageDigital" />
      </a>
      <div class="auth-icon" [class.auth-icon--success]="successMessage">
        <i
          class="bi"
          [ngClass]="successMessage ? 'bi-send-check' : 'bi-key'"
        ></i>
      </div>
      <header class="auth-heading">
        <h1 gdClarityUnmask id="forgot-title">Recuperá tu contraseña</h1>
        <p *ngIf="!successMessage">
          Ingresá tu correo y te enviaremos las instrucciones para volver a
          acceder a tu cuenta.
        </p>
        <p *ngIf="successMessage">
          Revisá tu bandeja de entrada y seguí los pasos para crear una nueva
          contraseña.
        </p>
      </header>

      <form
        *ngIf="!successMessage"
        class="auth-form"
        (submit)="$event.preventDefault(); submit()"
        novalidate
      >
        <div class="auth-field">
          <label for="forgot-email">Correo electrónico</label>
          <div class="auth-input">
            <i class="bi bi-envelope" aria-hidden="true"></i>
            <input
              id="forgot-email"
              type="email"
              class="form-control"
              [formControl]="email"
              placeholder="nombre@correo.com"
              autocomplete="email"
              [attr.aria-invalid]="email.touched && email.invalid"
            />
          </div>
          <div class="auth-validation" *ngIf="email.touched && email.invalid">
            Ingresá un correo electrónico válido.
          </div>
        </div>
        <button type="submit" class="auth-button" [disabled]="loading">
          <gd-inline-spinner *ngIf="loading" size="sm" tone="current" />
          <i *ngIf="!loading" class="bi bi-send" aria-hidden="true"></i>
          {{ loading ? "Enviando…" : "Enviar instrucciones" }}
        </button>
      </form>

      <div *ngIf="successMessage" class="auth-status auth-status--success">
        <i class="bi bi-check-circle-fill"></i><span>{{ successMessage }}</span>
      </div>
      <div *ngIf="errorMessage" class="auth-status auth-status--error">
        <i class="bi bi-exclamation-circle-fill"></i
        ><span>{{ errorMessage }}</span>
      </div>
      <a routerLink="/login" class="auth-back"
        ><i class="bi bi-arrow-left"></i> Volver al inicio de sesión</a
      >
    </div>
  </section>
</main>
